import React from 'react';
import { Option, Select } from 'carbon-react/lib/components/select';

import { useIntl } from '@futrli/localisation';
import { useI18nConstants } from '@futrli/predict/report-builder/use-i18n-constants';

import { adaptSelectChange } from '../../../../utils/carbon-select';

interface MonthsOfYearMenuProps {
  className?: string;
  disabled?: boolean;
  error?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  size?: 'small' | 'medium' | 'large';
}

export const MonthsOfYearMenu = ({ disabled = false, error = false, onChange, value, size }: MonthsOfYearMenuProps) => {
  const intl = useIntl();

  const label = intl.formatMessage({
    id: 'predict.output_on_month',
    defaultMessage: 'Output on month'
  });
  const { monthsOfTheYear: months } = useI18nConstants();

  return (
    <div style={{ width: 185 }}>
      <Select
        data-testid="Repeat"
        autoComplete="off"
        onChange={adaptSelectChange(onChange)}
        value={value ?? ''}
        label={label}
        disabled={disabled}
        error={error}
        size={size}
        mb={0}
      >
        {months.map((month, index) => (
          <Option key={month} value={String(index + 1)} text={month} />
        ))}
      </Select>
    </div>
  );
};
